module.exports = __webpack_public_path__ + "static/media/IMG_5491.1ec432d4.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/IMG_5491.PNG
// module id = 554
// module chunks = 0